module.exports = __webpack_public_path__ + "media/ritter.9ed9a08b.mp3";